import { useState, useEffect } from 'react';
import { Modal, Button, Form, Alert, Table } from 'react-bootstrap';

const CashSessionClose = ({ show, onClose, onSubmit, session }) => {
  const [formData, setFormData] = useState({
    monto_real: '',
    observaciones: '',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Función para convertir a número de forma segura
  const toNumber = (value) => {
    const num = parseFloat(value);
    return isNaN(num) ? 0 : num;
  };

  // Convertir todos los valores a números
  const montoInicial = toNumber(session?.monto_inicial);
  const montoVentasEfectivo = toNumber(session?.monto_ventas_efectivo);
  const montoIngresos = toNumber(session?.monto_ingresos);
  const montoRetiros = toNumber(session?.monto_retiros);
  const montoEsperado = toNumber(session?.resumen?.monto_esperado);
  const montoReal = toNumber(formData.monto_real);
  const diferencia = montoReal - montoEsperado;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validaciones
    if (!formData.monto_real || parseFloat(formData.monto_real) < 0) {
      setError('Debes ingresar el monto real contado');
      return;
    }

    try {
      setLoading(true);
      setError(null);

      const result = await onSubmit({
        monto_real: parseFloat(formData.monto_real),
        observaciones: formData.observaciones,
      });

      if (!result.success) {
        setError(result.message || 'Error al cerrar la sesión');
      }
    } catch (err) {
      if (err.response?.status === 404) {
  setError('No puedes cerrar esta caja porque fue abierta por otro cajero.');
} else {
  setError(err.response?.data?.message || 'Error al cerrar la sesión');
}
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onClose} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>
          <i className="bi bi-door-closed me-2"></i>
          Cerrar Caja
        </Modal.Title>
      </Modal.Header>

      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          {error && (
            <Alert variant="danger" dismissible onClose={() => setError(null)}>
              {error}
            </Alert>
          )}

          {/* Resumen de la Sesión */}
          <div className="mb-4">
            <h6 className="mb-3">Resumen de la Sesión</h6>
            <Table bordered size="sm">
              <tbody>
                <tr>
                  <td><strong>Monto Inicial:</strong></td>
                  <td className="text-end">
                    ${montoInicial.toFixed(2)}
                  </td>
                </tr>
                <tr>
                  <td><strong>Ventas en Efectivo:</strong></td>
                  <td className="text-end text-success">
                    + ${montoVentasEfectivo.toFixed(2)}
                  </td>
                </tr>
                <tr>
                  <td><strong>Ingresos Adicionales:</strong></td>
                  <td className="text-end text-success">
                    + ${montoIngresos.toFixed(2)}
                  </td>
                </tr>
                <tr>
                  <td><strong>Retiros:</strong></td>
                  <td className="text-end text-danger">
                    - ${montoRetiros.toFixed(2)}
                  </td>
                </tr>
                <tr className="table-primary">
                  <td><strong>Monto Esperado:</strong></td>
                  <td className="text-end fw-bold">
                    ${montoEsperado.toFixed(2)}
                  </td>
                </tr>
              </tbody>
            </Table>
          </div>

          <hr />

          {/* Formulario de Cierre */}
          <Form.Group className="mb-3">
            <Form.Label>
              Monto Real Contado <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="number"
              step="0.01"
              name="monto_real"
              value={formData.monto_real}
              onChange={handleChange}
              placeholder="0.00"
              required
              autoFocus
            />
            <Form.Text className="text-muted">
              Cuenta el efectivo físico en la caja
            </Form.Text>
          </Form.Group>

          {/* Mostrar Diferencia */}
          {formData.monto_real && (
            <div className={`alert ${diferencia === 0 ? 'alert-success' : diferencia > 0 ? 'alert-warning' : 'alert-danger'}`}>
              <strong>Diferencia: </strong>
              {diferencia > 0 && '+ '}
              ${Math.abs(diferencia).toFixed(2)}
              {diferencia > 0 && ' (Sobrante)'}
              {diferencia < 0 && ' (Faltante)'}
              {diferencia === 0 && ' (Cuadra exacto ✓)'}
            </div>
          )}

          <Form.Group className="mb-3">
            <Form.Label>Observaciones</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              name="observaciones"
              value={formData.observaciones}
              onChange={handleChange}
              placeholder="Notas sobre el cierre (opcional)"
            />
          </Form.Group>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={onClose} disabled={loading}>
            Cancelar
          </Button>
          <Button variant="danger" type="submit" disabled={loading}>
            {loading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" />
                Cerrando...
              </>
            ) : (
              <>
                <i className="bi bi-check-circle me-2"></i>
                Cerrar Caja
              </>
            )}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default CashSessionClose;